module.exports = __webpack_public_path__ + "static/media/AB_K36_1.8bc57d82.jpg";